export const rounding = (num: number) => Math.ceil(num * 100) / 100;

export function clamp(value: number, min?: number, max?: number) {
    if (min === undefined && max === undefined) {
        return value;
    }

    if (min !== undefined && max === undefined) {
        return Math.max(value, min);
    }

    if (min === undefined && max !== undefined) {
        return Math.min(value, max);
    }

    return Math.min(Math.max(value, min!), max!);
}
